<template>
  <div class="container-fluid mb-4 py-3 bg-secondary-3">
    <div class="row">
      <div
        :class="[
          'col-sm-12 col-md-2',
          { 'border-right': !isMobile, 'border-bottom pb-2 mx-2': isMobile },
        ]"
      >
        <div class="row">
          <div
            :class="[
              'col-12 d-flex font-weight-normal text-mobile',
              { 'justify-content-center': !isMobile, 'px-2': isMobile },
            ]"
          >
            Mes de Nacimiento
          </div>
          <div
            :class="[
              'col-12 d-flex h-100',
              {
                'justify-content-center pt-3': !isMobile,
                'py-2 pl-1': isMobile,
              },
            ]"
          >
            <em
              class="fas fa-calendar-alt color-primary-2 mr-2 shadow bg-white rounded-circle p-2 size-mobile"
            />
            <span :class="['mt-1', { 'bold text-mobile': isMobile }]">
              {{ value.monthName }}
            </span>
          </div>
        </div>
      </div>
      <div :class="['col-sm-12 col-md-10 px-4']">
        <div class="row">
          <div
            :class="[
              'col-12 font-weight-normal text-mobile',
              { 'pl-1 mb-2 ': !isMobile, 'mt-3 px-2': isMobile },
            ]"
          >
            Año de Nacimiento
          </div>
        </div>
        <div class="row d-flex flex-row justify-content-center">
          <div
            v-for="item in value.metaPrItems"
            :key="item.metaPrId"
            :class="['col-md-1 px-1 col-6', { 'mt-3': isMobile }]"
          >
            <custom-drop-down
              v-model="item.gradeId"
              class="text-bold height-wrapper"
              :regular-label="isMobile"
              :clearable="false"
              :options="schoolGrades"
              :label="`${item.year}:`"
              fieldkey="id"
              fieldname="name"
              :disabled="disabled"
              @input="trackChange(item)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';

export default {
  name: 'MetaPrRow',
  components: {
    CustomDropDown,
  },
  data() {
    return {};
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    schoolGrades: {
      type: Array,
      required: true,
    },
    trackChanges: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    trackChange(item) {
      if (this.trackChanges) {
        item.hasChanged = true;
      }
    },
  },
};
</script>

<style scoped>
.text-bold >>> .vs__selected {
  letter-spacing: 0;
  color: #000 !important;
  font-weight: bold !important;
}

.height-wrapper >>> .vs__selected-options {
  max-height: 1.75rem;
}
@media only screen and (max-width: 375px) {
  .text-mobile {
    font-size: 12px;
  }

  .size-mobile {
    font-size: 12px;
  }

  ::v-deep .vs__search {
    font-size: 12px !important;
  }

  ::v-deep .vs__selected {
    font-size: 12px !important;
  }

  ::v-deep .vs__dropdown-menu {
    font-size: 12px !important;
  }

  ::v-deep .data-name {
    font-size: 12px !important;
    font-weight: normal;
  }
}
</style>
